<template>
  <div>
    <div v-for="(item,index) in list" :key="index" class="item" @click="openDetails(item)" v-if="item.type!=3">
      <p class="title">{{ item.title }}</p>
      <div class="message">
        <p><span>发布机关：</span>{{ item.user_name }}</p>
        <p><span>发布时间：</span>{{ item.time }}</p>
      </div>
    </div>
    <!-- 分页 -->
    <page :total="tablePage.total" class="pagination" :page="tablePage.currentPage" @currentPage="currentPage"/>
  </div>
</template>

<script>
import page from "@/components/page/pages";
import {recommendLists} from "@/api/interfaceApi";

export default {
  components: {page},
  data() {
    return {
      list: [],
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      cid: 0,
    }
  },
  watch: {
    cityNo(e) {
      this.tablePage.currentPage = 1;
      this.list = [];
      this.getLocationPolicy();
    }
  },
  props: {
    cityNo: {
      type: [String, Number],
      default: 0,
    },
    cityList: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  mounted() {
    this.getLocationPolicy();
  },
  methods: {
    getLocationPolicy() {
      recommendLists({
        advLat: this.cityList.lng,
        advLng: this.cityList.lat,
        advNetwork: 4,
        advPlatform: 3,
        city: this.cityList.id,
        nid: 97,
        page: this.tablePage.currentPage,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        cid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then(res => {
        if (res.code == 200) {
          this.list = res.content;
          this.tablePage.total = res.total;
          window.scrollTo(0, 60);
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getLocationPolicy();
    },
    //打开详情
    openDetails(item) {
      let routeData = this.$router.resolve({
        name: "DynamicDetail",
        query:{
          id:item.id,
          type:3,
        },
        params:{cid:this.cid},
        path: '/article/DynamicDetail',
      });
      window.open(routeData.href, '_blank')
    }
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
  }
};
</script>

<style lang="scss" scoped>
.item {
  padding-top: 30px;
  cursor: pointer;
  border-bottom: 1px dashed #ddd;
  padding-bottom: 12px;

  .title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-block-end: 0px;
    margin-block-start: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp:1;
    word-break:break-all;
    display:-webkit-box;
    -webkit-box-orient:vertical;
  }

  .message {
    font-size: 14px;
    padding-top: 5px;

    p {
      padding-bottom: 0px;
    }

    span {
      color: #aaa;
    }
  }
}
</style>